import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { NotificationManager } from 'react-notifications';
import { Modal } from 'react-bootstrap';
import { showLoader, hideLoader } from '../../../../store/common/slice';
import { useAccessToken } from '../../../../common/hooks/useAccessToken';
import Button from '../../../../common/Button';
import { ReconciliationModalStyled } from '../BankAdjustmentsNew.styled';
import CardsMatch from './CardsMatch';

const AutoCompareModal = ({ show, onModalHide, matches }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const client = useAccessToken();

    const [disabledApproveBtn, setDisabledApproveBtn] = useState(false);
    const [checkedMatches, setCheckedMatches] = useState([]);

    useEffect(() => {
        const matched = (matches ?? []).map(info => ({ info, checked: true }));
        setCheckedMatches(matched);
    }, [matches]);

    useEffect(() => {
        const isChecked = checkedMatches.find(match => match.checked === true);
        setDisabledApproveBtn(isChecked == null);
    }, [checkedMatches]);

    const onCheckboxChange = (i, state) => {
        checkedMatches[i].checked = state;
        setCheckedMatches([...checkedMatches]);
    };

    const onApproveClick = async () => {
        const paymentIDs = [];
        checkedMatches.forEach(match => {
            if (match.checked) match.info.bllinkRecord.forEach(record => paymentIDs.push(record.paymentID))
        });
        dispatch(showLoader());
        for (const id of paymentIDs) {
            const response = await client.post(`/managers/markAsApproved/${id}`);
            if (response.success) {
                NotificationManager.success(t('expenses.bank_adjustments.approved_transaction', { id }));
            } else {
                NotificationManager.error(t('expenses.bank_adjustments.not_approved_transaction', { id }));
            }
        }
        dispatch(hideLoader());
        onModalHide();
        setTimeout(() => window.location.reload(), 2000);
    };

    return (
        <ReconciliationModalStyled
            show={show}
            onHide={onModalHide}
            centered
            className='header-with-bg'
            size="xl"
        >
            <span className='modal-close' onClick={onModalHide}>&#215;</span>

            <Modal.Header>
                <Modal.Title className='text-center'>
                    {t('expenses.bank_adjustments.auto_match_title')}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {matches.length > 0 && (<div className='modal-subheader'>{t('expenses.bank_adjustments.choose_pairs')}</div>)}
                <div className='card-pairs-wrapper'>
                    {matches.length === 0 && t('expenses.bank_adjustments.no_matches')}
                    {matches.length > 0 && matches.map((match, i) => (
                        <CardsMatch
                            key={i}
                            order={i}
                            bllinkRecord={match.bllinkRecord}
                            bankRecord={match.bankRecord}
                            checked={checkedMatches[i]}
                            onCheckboxChange={onCheckboxChange}
                        />
                    ))}
                </div>
                {matches.length > 0 && (
                    <Button  onClick={onApproveClick} disabled={disabledApproveBtn}className='approve-btn'
                    >
                        {t('expenses.bank_adjustments.approve_all')}
                    </Button>
                )}
            </Modal.Body>
        </ReconciliationModalStyled>
    );
};

export default AutoCompareModal;
